import { render } from "./ResourcesView.vue?vue&type=template&id=41b49d34&scoped=true"
import script from "./ResourcesView.vue?vue&type=script&lang=js"
export * from "./ResourcesView.vue?vue&type=script&lang=js"

import "./ResourcesView.vue?vue&type=style&index=0&id=41b49d34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b49d34"]])

export default __exports__